import React, {createContext, useContext, ReactNode} from 'react';
import {colorsByLabel, ColorsType} from '../../styles/Colors';
import {
  FontsType,
  styleByLabel,
  StyleType,
  typeByLabel,
} from '../../styles/Fonts';

type ThemeType = {
  fonts: FontsType;
  fontStyles: StyleType;
  colors: ColorsType;
};

const ThemeContext = createContext<ThemeType | undefined>(undefined);

type ThemeProviderProps = {
  label: 'PRIMARY' | 'SECONDARY';
  children: ReactNode;
};

const combinedTheme = (label: string) => {
  const fonts = typeByLabel[label];
  const fontStyles = styleByLabel[label](fonts);
  const colors = colorsByLabel[label];

  if (!fonts || !fontStyles || !colors) {
    throw new Error(`Tema no encontrado para la label: ${label}`);
  }

  return {colors, fonts, fontStyles};
};

export const ThemeProvider = ({label, children}: ThemeProviderProps) => {
  const theme = combinedTheme(label);

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme debe ser usado dentro de ThemeProvider');
  }
  return context;
};

export default ThemeProvider;
